/* ============================================================
   Cleara — Plasma Pen 6 en 1 (slug 'cleara').
   Cargado por layout/landing.liquid (case 'cleara').
   Bloques: galería (thumbs) · selección de bundle (.cl-bundle, actualiza precio
   hero+sticky) · tabs · sticky bar · disparo del modal Releasit COD.
   Patrón Releasit (per-unit + quantity): cada bundle = 1 variante con precio
   POR UNIDAD; mandamos quantity = N para que el pedido lleve las unidades reales
   (Dropi) y el total quede en el precio del bundle. NO usar _rsiV2.setState como
   primer path. Ver memory/project_bundles_as_variants.
   ============================================================ */

/* ---------- galería thumbs ---------- */
document.querySelectorAll('.cl-thumb').forEach(function (t) {
  t.addEventListener('click', function () {
    document.querySelectorAll('.cl-thumb').forEach(function (x) { x.classList.remove('active'); });
    t.classList.add('active');
    var main = document.getElementById('mainImg');
    if (main && t.dataset.img) main.src = t.dataset.img;
  });
});

/* ---------- tabs ---------- */
document.querySelectorAll('.cl-tab-btn').forEach(function (btn) {
  btn.addEventListener('click', function () {
    document.querySelectorAll('.cl-tab-btn').forEach(function (x) { x.classList.remove('active'); });
    document.querySelectorAll('.cl-tab-panel').forEach(function (x) { x.classList.remove('active'); });
    btn.classList.add('active');
    var p = document.getElementById(btn.dataset.tab);
    if (p) p.classList.add('active');
  });
});

/* ---------- sticky bar ---------- */
(function () {
  var sticky = document.getElementById('sticky'), box = document.getElementById('buybox');
  if (!sticky || !box) return;
  window.addEventListener('scroll', function () {
    var r = box.getBoundingClientRect();
    if (r.bottom < 120) sticky.classList.add('show'); else sticky.classList.remove('show');
  });
})();

/* ============================================================
   Releasit COD trigger + selección de bundle
   ============================================================ */
var CLEARA_RELEASIT_SELECTORS = [
  '#rsi_buy_now_button',
  '.rsi_buy_now_button',
  '._rsi-buy-now-button',
  '._rsi-buy-now-button-app-block-hook button',
  '._rsi-buy-now-button-app-block-hook a',
  '.rsi-btn-skel'
];

function clearaFindReleasitButton() {
  for (var i = 0; i < CLEARA_RELEASIT_SELECTORS.length; i++) {
    var el = document.querySelector(CLEARA_RELEASIT_SELECTORS[i]);
    if (el) return el;
  }
  return null;
}

var clearaSelectedVariantId = null;
var clearaSelectedQty = 1;

function clearaSetVariantOnAllForms(variantId, qty) {
  if (!variantId) return;
  var q = parseInt(qty, 10);
  if (!q || q < 1) q = 1;
  document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
    input.value = String(q);
    input.setAttribute('value', String(q));
  });
  if (window.productData) { window.productData.quantity = q; }
  if (window.productData && Array.isArray(window.productData.variants)) {
    var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
    if (v) {
      window.productData.selected_or_first_available_variant = v;
      window.productData.selected_variant = v;
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
        document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
      } catch (e) {}
    }
  }
}

/* ---------- selección de bundle (precio hero+sticky + variante) ---------- */
var clBundles = document.querySelectorAll('.cl-bundle');
function selBundle(b) {
  clBundles.forEach(function (x) { x.classList.remove('sel'); });
  b.classList.add('sel');
  var p = '$' + b.dataset.price, o = b.dataset.old, s = '-' + b.dataset.save;
  var hp = document.getElementById('heroPrice'), ho = document.getElementById('heroOld');
  var sp = document.getElementById('stickyPrice'), so = document.getElementById('stickyOld'), ss = document.getElementById('stickySave');
  if (hp) hp.textContent = p;
  if (ho) ho.textContent = o;
  if (sp) sp.textContent = p;
  if (so) so.textContent = o;
  if (ss) ss.textContent = s;
  var id = b.getAttribute('data-bundle-variant-id');
  if (id) {
    clearaSelectedVariantId = id;
    clearaSelectedQty = parseInt(b.getAttribute('data-bundle-qty'), 10) || 1;
    clearaSetVariantOnAllForms(clearaSelectedVariantId, clearaSelectedQty);
  }
}
clBundles.forEach(function (b) { b.addEventListener('click', function () { selBundle(b); }); });
window.selBundle = selBundle;

function clearaTriggerCOD(btn) {
  var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || clearaSelectedVariantId;
  var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || clearaSelectedQty;
  if (variantId) clearaSetVariantOnAllForms(variantId, qty);
  setTimeout(function () {
    var releasitBtn = clearaFindReleasitButton();
    if (releasitBtn) { releasitBtn.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = clearaFindReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }, 50);
}
window.clearaTriggerCOD = clearaTriggerCOD;
window.openCheckout = function () { clearaTriggerCOD(null); };

/* ---------- init: bundle preseleccionado (.sel o el primero) ---------- */
(function () {
  var active = document.querySelector('.cl-bundle.sel') || document.querySelector('.cl-bundle');
  if (active) selBundle(active);
})();
